module.exports = __webpack_public_path__ + "static/media/footorMobileOrange.b0dad7dd.png";